import { REVENUE_CATEGORY_CONFIG } from '../utils/summaryOfRevenuesAndExpendituresUtils';

export const OVERVIEW_SOURCES = [
  ...REVENUE_CATEGORY_CONFIG.map((category, i) => ({
    label: category.key === 'taxes' ? 'Property taxes' : category.label, side: 'revenue', id: [
      'revenues_tax_revenues', 'revenues_licenses_permits', 'revenues_intergovernmental',
      'revenues_charges_for_services', 'revenues_other_revenues', 'revenues_transfers_in_from',
    ][i],
  })),
  { label: 'Town services', side: 'spending', id: 'expenditures_town' },
  { label: 'Education', side: 'spending', id: 'expenditures_education' },
  { label: 'Debt & transfers out', side: 'spending', id: 'expenditures_debt_transfers_out' },
];

// Ignore stored subtotal fields while adding leaves, so totals are counted once.
export function sumBudgetNode(node) {
  if (typeof node === 'number') return Number.isFinite(node) ? node : null;
  if (!node || typeof node !== 'object' || Array.isArray(node)) return null;
  const values = Object.entries(node).filter(([key]) => !/^total$/i.test(key))
    .map(([, value]) => sumBudgetNode(value)).filter(value => value !== null);
  if (values.length) return values.reduce((sum, value) => sum + value, 0);
  const total = Object.entries(node).find(([key]) => /^total$/i.test(key))?.[1];
  return typeof total === 'number' && Number.isFinite(total) ? total : null;
}

export function buildBudgetOverview(documents, year) {
  const rows = OVERVIEW_SOURCES.map(source => {
    const node = documents[source.id]?.[String(year)];
    return { ...source, value: sumBudgetNode(node?.Approved ?? node?.Adopted) };
  });
  const complete = rows.every(row => row.value !== null);
  const revenue = rows.filter(row => row.side === 'revenue');
  const spending = rows.filter(row => row.side === 'spending');
  return { complete, revenue, spending,
    revenueTotal: complete ? revenue.reduce((sum, row) => sum + row.value, 0) : null,
    spendingTotal: complete ? spending.reduce((sum, row) => sum + row.value, 0) : null,
  };
}
